export function useBusinessHours(hoursFull: Business['hoursFull']) {
  const { currentTime, currentDayAsNumber } = useTime()

  const isOpenNow = computed(() => {
    if (!hoursFull?.length)
      return false

    const currentDay = hoursFull.find(day => day.day === Number(currentDayAsNumber.value))
    if (!currentDay)
      return false

    const startTime = new Date(`1970-01-01T${currentDay.start}`)
    const endTime = new Date(`1970-01-01T${currentDay.end}`)
    const now = new Date(`1970-01-01T${currentTime.value}`)
    return now >= startTime && now <= endTime
  })

  return {
    isOpenNow,
  }
}
